import React, { FC, ReactNode } from 'react'

import { ContentStack, ContentStackProps } from '../../layout/ContentStack'
import { SubHeading, Body } from '../../typography/Text'

export type ErrorMessage = {
  summary: ReactNode
  description?: ReactNode
}

export type ErrorMessageBoxProps = Omit<ContentStackProps, 'children'> &
  ErrorMessage

export const ErrorMessageBox: FC<ErrorMessageBoxProps> = ({
  summary,
  description,
  ...props
}) => {
  return (
    <ContentStack layerStyle="fail" p="md" {...props}>
      <SubHeading>{summary}</SubHeading>
      {description ? <Body>{description}</Body> : null}
    </ContentStack>
  )
}
